import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=ca5daa20&scoped=true&"
import script from "./successPage.vue?vue&type=script&lang=js&"
export * from "./successPage.vue?vue&type=script&lang=js&"
import style0 from "./successPage.vue?vue&type=style&index=0&id=ca5daa20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5daa20",
  null
  
)

export default component.exports